// Mock theme data for Consultant Theme page
export interface ThemeData {
  name: string;
  primaryColor: string;
  secondaryColor: string;
  accentColor: string;
  backgroundColor: string;
  textPrimary: string;
  textSecondary: string;
  logoUrl: string;
  logoName: string;
  logoSize: string;
  logoUploadedAt: string;
}

export const defaultTheme: ThemeData = {
  name: 'Corporate Blue',
  primaryColor: '2bd4bd',
  secondaryColor: '549289',
  accentColor: 'FFB74D',
  backgroundColor: 'f9fbfb',
  textPrimary: '0f1a18',
  textSecondary: '64748b',
  logoUrl: 'https://lh3.googleusercontent.com/aida-public/AB6AXuCuTKEJ2qSsCEhFvobnbv9Q-Uzb78-d7E1woVRxraI9BBvBWBlO8O9mDX0QOpsVTsmNUyRU0UZ_5DxmtSQgfU_0uWr75XTXrMhum2YBAUsSwVMtAk_F2CGpQ71-wMDRoBvXYhQppHpc0vokjmJBLlAjPEASZM-d6a6-lCX3-LH-Vu6JmLvPbkytaVpGcdcgtdBJt7rOAXoiFOyk1QVVOaFxxTL0IvjaxUodJtgJpsFok17TitP_MptPETeAQOfT1fD0dO9ldVADaKk',
  logoName: 'acme-logo-brand.svg',
  logoSize: '24KB',
  logoUploadedAt: 'just now'
};

export const getThemeDefaults = (): ThemeData => {
  return { ...defaultTheme };
};

